const alertTempl = require('sma.admin/components/partials/alert.mustache')

class Alert extends Backbone.View {
	get events() {
		return {
			'click .sma-alert-close': 'closeAlert',
		};
	}

	initialize(options) {
		// Check if a message was passed in
		if (options.message === undefined) {
			throw new Error('Message is not defined.');
		}

		this.message = options.message;

		// Types of alerts with their associated icon class
		const alertTypes = {
			success: { name: 'success', icon: 'ui-1_check-bold' },
			warning: { name: 'warning', icon: 'ui-3_alert' },
			danger: { name: 'danger', icon: 'ui-3_alert' },
			info: { name: 'info', icon: 'ui-2_alert-circle-i' },
		};

		// Check if a type was passed in
		if (options.type) {
			const type = options.type.toLowerCase();

			if (type in alertTypes) {
				this.type = alertTypes[type];
			} else {
				throw new Error(type + ' is not a valid alert type');
			}
		} else {
			throw new Error('type is not defined');
		}

		this.setElement($('body'));
		this.render();
	}

	closeAlert(e) {
		$(e.currentTarget).closest('.sma-alert').remove();
	}

	render() {
		const context = {
			type: this.type,
			message: this.message,
		};

		// Build the alert mand add it to the start of the body
		this.$el.prepend($(alertTempl(context)));

		// Get the first element in dom. Since they're prepended, the newest alert will
		// be the first element returned.
		const ele = this.$el.find('.sma-alert:first');
	
		// Animate and remove after a couple seconds
		ele.animate({
			right: 32,
			opacity: 1
		}, 400, () => {
			setTimeout(() => {
				ele.animate({
					right: -300,
					opacity: 0
				}, 400, () => {
					ele.remove();
				});
			}, 3000);
		});
	}
}

module.exports = Alert;



// WEBPACK FOOTER //
// ../apps/chide/products/smapply/static/sma.admin/components/alert.js